import Vue from 'vue'
import firebase from 'firebase'
import Antd from 'ant-design-vue'
import App from './App.vue'
import VueRouter from 'vue-router'


import credentials from './credentials.json'

import Permission from './permissions'

import Loading from '@/components/Loading'

import Home from '@/views/Home'

import Login from '@/views/Login'
import ForgotPassword from '@/views/ForgotPassword';
import Logout from '@/views/Logout'
import Register from '@/views/register/Register';
import PersonalDetails from '@/views/register/PersonalDetails'

import Dashboard from '@/views/Dashboard'
import Cohort from '@/views/dashboard/Cohort'
import Student from '@/views/dashboard/Student'
import Tasks from '@/views/dashboard/Tasks'

import 'ant-design-vue/dist/antd.less'

import services from '@/services/services';

Vue.config.productionTip = false
Vue.use(VueRouter);
Vue.use(Antd);
Vue.component('loading', Loading)

let app = '';

firebase.initializeApp(credentials);

Vue.prototype.$db = firebase.firestore();
Vue.prototype.$permission = Permission;

Vue.prototype.$services = services;

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '*', redirect: '/' },
    { path: '/', name: 'Home', component: Home },
    { path: '/login', name: 'Login', component: Login },
    { path: '/forgot-password', name: 'ForgotPassword', component: ForgotPassword },
    { path: '/logout', name: 'Logout', component: Logout,
      meta: { requiresAuth: true }
    },
    { path: '/register', name: 'Register', component: Register },
    { path: '/register/personal-details', name: 'PersonalDetails', component: PersonalDetails,
      meta: { requiresAuth: true }
    },
    { path: '/dashboard', redirect: '/dashboard/cohort' },
    { path: '/dashboard', name: 'Dashboard', component: Dashboard,
      meta: { requiresAuth: true },
      children: [
        {
          path: 'student',
          component: Student
        },
        {
          path: 'cohort',
          component: Cohort
        },
        {
          path: 'tasks',
          component: Tasks
        }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;

  Vue.prototype.$user = currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !currentUser) next('/login');
  else if (!requiresAuth && currentUser) next('/dashboard');
  else next();
});

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      render: h => h(App),
    }).$mount('#app')
  }
});